import {
  loadStateProcessorModule,
  stateProcessorConfigFor,
} from '@primer-io/sdk-bdc-core/backend-driven';
import { PrimerJSLogger } from '@primer-io/sdk-utils/PrimerJSLogger';

/** Starts loading the environment's bundle, so backend-driven methods find it ready. */
export function preloadStateProcessor(decodedClientToken: object): void {
  const { env } = decodedClientToken as { env?: string };
  if (!env) {
    return;
  }
  const config = stateProcessorConfigFor(env);
  PrimerJSLogger.info('BDC: preloading state processor', {
    env,
    manifestUrl: config.manifestUrl,
  });
  loadStateProcessorModule(config).catch((error: unknown) =>
    PrimerJSLogger.debug('BDC: state processor preload failed', error),
  );
}
